[
  {
    "path": "/blog/what-is-answer-engine-optimization",
    "title": "What is answer engine optimization?",
    "published": "2026-10-14",
    "summary": "When a customer asks an AI assistant who to hire, it names a few businesses. Answer engine optimization is the work of getting your business named among them."
  },
  {
    "path": "/blog/local-services-benchmark",
    "title": "Who AI assistants recommend for local services",
    "published": "2026-10-14",
    "summary": "We asked three AI assistants who to hire in ten industries in Dallas, Nashville and Boise: who they named, how often that changed, and what they cited."
  },
  {
    "path": "/blog/get-listed-where-ai-assistants-look",
    "title": "How to get listed where AI assistants look",
    "published": "2026-10-14",
    "summary": "How to get onto the directories, review sites and roundups AI assistants cite, and what to publish on your own site."
  },
  {
    "path": "/blog/how-ai-assistants-choose-a-business",
    "title": "How AI assistants choose which business to recommend",
    "published": "2026-10-14",
    "summary": "What AI assistants read before they name a local business, why the answer changes each time you ask and from city to city, and what you can do about it."
  },
  {
    "path": "/blog/how-to-measure-ai-visibility",
    "title": "Ways to measure AI visibility, and what each one misses",
    "published": "2026-10-14",
    "summary": "Asking once, asking nationally, folding every AI assistant into one score: each way of measuring AI visibility answers a different question."
  }
]
